// mediaTagging/TaggingApiClient.js — die AJAX-Transport-Naht des Tag-Stacks (get_tags + admin_changetag + admin_changetags).
//
// Bewusst DÜNN: nur Transport, keine DOM-/Response-Behandlung (das refreshKeywords/attachKeyword/Toast-Handling
// bleibt im Legacy-Consumer documents.js). Zweck (M3 „FUTURE DAL"): die zwei Endpunkte an EINER Stelle, testbar,
// und der einzige Ort, den der kommende TagRepository-Umbau (Plan backend_tagging-schema) berührt.
//
// Formtreu: gibt jQuery-jqXHR zurück (wie die bisherigen Inline-$.ajax-Aufrufe), damit die Consumer
// (TaggingCore.loadTagsFromApi via .then, storeChangedTag via .done/.fail) unverändert weiterlaufen.

export function createTaggingApiClient({ url = '/includes/ajax.php' } = {}) {
    const $ = window.$;

    return {
        // Alle Tags eines Dokuments laden (Consumer: TaggingCore.loadTagsFromApi).
        loadTags: (docId) =>
            $.ajax({ url, type: 'POST', dataType: 'json', data: { action: 'get_tags', document: docId } }),

        // Eine Tag-Änderung (anlegen/ändern/löschen) speichern. stag/tag sind bereits API-serialisiert
        // (TagBoxModel.toApiRequest). Response: { success, mainKeywords, subKeywords, hiddenKeywords, changedTagText }.
        saveTag: (docId, stag, tag) =>
            $.ajax({ url, type: 'POST', dataType: 'json', data: { action: 'admin_changetag', document: docId, stag, tag } }),

        // Many changes of one document in ONE request (plan bugfix_2026-10-06_permission-tagging, stage 2c).
        // changes = [{ stag, tag }], each serialised like saveTag's. Sent as ONE JSON string (form fields would hit
        // max_input_vars); the server turns it back into saveTag's form-encoded shape. Response: { success (all ok),
        // results: [one per change, same order — each like a saveTag response], mainKeywords, subKeywords, hiddenKeywords }.
        saveTags: (docId, changes) =>
            $.ajax({ url, type: 'POST', dataType: 'json', data: { action: 'admin_changetags', document: docId, changes: JSON.stringify(changes) } }),
    };
}
